import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Button } from './Button';
import { XIcon, ShoppingCartIcon, ArrowRightIcon } from 'lucide-react';
interface CartModalProps {
  isOpen: boolean;
  onClose: () => void;
  onGoToCart: () => void;
  onContinueShopping: () => void;
  productName: string;
}
export const CartModal: React.FC<CartModalProps> = ({
  isOpen,
  onClose,
  onGoToCart,
  onContinueShopping,
  productName
}) => {
  const handleContinueShopping = () => {
    onClose(); // Zavře modal s animací
    onContinueShopping(); // Volá callback
  };
  return <AnimatePresence data-id="element-218">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4" onClick={onClose} data-id="element-219">
          <motion.div initial={{
        scale: 0.9,
        y: 20,
        opacity: 0
      }} animate={{
        scale: 1,
        y: 0,
        opacity: 1
      }} exit={{
        scale: 0.9,
        y: 20,
        opacity: 0
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 300
      }} className="bg-gray-900 border border-gray-800 rounded-xl p-6 max-w-md w-full shadow-[0_20px_50px_-12px_rgba(34,197,94,0.3)] relative" onClick={e => e.stopPropagation()} data-id="element-220">
            <button className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors" onClick={onClose} data-id="element-221">
              <XIcon className="w-5 h-5" data-id="element-222" />
            </button>
            <div className="flex items-center mb-4" data-id="element-223">
              <div className="w-12 h-12 bg-green-500/20 rounded-full flex items-center justify-center mr-3" data-id="element-224">
                <ShoppingCartIcon className="w-6 h-6 text-green-500" data-id="element-225" />
              </div>
              <h3 className="text-xl font-bold" data-id="element-226">Produkt přidán do košíku</h3>
            </div>
            <div className="border-t border-b border-gray-800 py-4 my-4" data-id="element-227">
              <p className="text-center text-gray-300" data-id="element-228">
                <span className="font-medium text-white" data-id="element-229">{productName}</span>{' '}
                byl úspěšně přidán do vašeho košíku
              </p>
            </div>
            <div className="flex flex-col gap-3" data-id="element-230">
              <Button variant="primary" onClick={onGoToCart} className="luxury-button" data-id="element-231">
                <div className="flex items-center justify-center w-full" data-id="element-232">
                  <ShoppingCartIcon className="w-5 h-5 mr-2" data-id="element-233" />
                  <span data-id="element-234">PŘEJÍT DO KOŠÍKU</span>
                </div>
              </Button>
              <Button variant="outline" onClick={handleContinueShopping} className="shine" data-id="element-235">
                <div className="flex items-center justify-center w-full" data-id="element-236">
                  <ArrowRightIcon className="w-5 h-5 mr-2" data-id="element-237" />
                  <span data-id="element-238">POKRAČOVAT V NÁKUPU</span>
                </div>
              </Button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
};